export enum ROUTE_DIRECTION {
  Back = 'back',
  Forward = 'forward',
  Root = 'root'
}

export enum ROUTE_PATH {
  Global = 'global',
  PublicSite = 'public-site',
  UserAdmin = 'user-admin',
  UserConsumer = 'user-consumer',
  UserMerchant = 'user-merchant',
  UserStaff = 'user-staff',
  UserSupplier = 'user-supplier'
}

export enum ROUTE_PATH_GLOBAL { 
  Authenticate = 'authenticate',
  BuildInfo = 'build-info',
  Language = 'language'
}

export enum ROUTE_PATH_PUBLIC_SITE {
  Home = 'home'
}

export enum ROUTE_PATH_USER_ADMIN {
  BusinessORead = 'business-o-read',
  BusinessOReadList = 'business-o-read-list',
  Dashboard = 'dashboard',
  Home = 'home'
}

export enum ROUTE_PATH_USER_CONSUMER {
  BusinessORead = 'business-o-read',
  Dashboard = 'dashboard',
  Home = 'home'
}

export enum ROUTE_PATH_USER_MERCHANT {
  BusinessOCreate = 'business-o-create',
  BusinessORead = 'business-o-read',
  BusinessOReadList = 'business-o-read-list',
  BusinessOUpdate = 'business-o-update',
  Dashboard = 'dashboard',
  Home = 'home'
}

export enum ROUTE_PATH_USER_STAFF {
  Dashboard = 'dashboard',
  Home = 'home'
}

export enum ROUTE_PATH_USER_SUPPLIER {
  Dashboard = 'dashboard',
  Home = 'home'
}
